import React from "react";

import CityFrame from "./cityframe";

type Props = {
  props: { src: string; nation: string; prefecture: string };
};

const NationalPlate: React.FC<Props> = ({ props }) => {
  return (
    // <div className="w-full h-full flex justify-center items-center">
    <CityFrame props={props} />
    // </div>
  );
};

export default NationalPlate;
